import {createDivIn, createExternalImgIn, createParagraphIn, setElementOnClick} from '../../../shared/scripts/ui_utils/DomUtils'
import {TranslationObject} from '@colonist/i18n'
import IconX from '@static/images/icon_x.svg'

export class UIMMobileBottomDrawer {
    private readonly container: HTMLElement
    private readonly background: HTMLElement
    protected content: HTMLElement
    protected title: HTMLElement

    constructor(title: TranslationObject) {
        const body = document.body as HTMLElement
        this.container = createDivIn(body, 'drawer-container')
        this.createTitle(title)
        this.createContent()

        this.background = createDivIn(body, 'drawer-background')
        setElementOnClick(this.background, () => this.toggleDrawer())
    }

    private createTitle(title: TranslationObject) {
        const titleContainer = createDivIn(this.container, 'drawer-title')

        this.title = createParagraphIn(titleContainer, title, 'drawer-title-text')

        const crossContainer = createDivIn(titleContainer, 'in-game-information-title-container arrows-container')
        createExternalImgIn(crossContainer, IconX, {key: 'strings:colonistCommon.utils.emptyString'}, 'arrows')
        setElementOnClick(crossContainer, () => this.toggleDrawer())
    }

    private createContent() {
        const contentContainer = createDivIn(this.container, 'drawer-content')
        this.content = contentContainer
    }

    toggleDrawer() {
        this.container.remove()
        this.background.remove()
    }
}
